import"./MediaImage.css.ts.vanilla.css";var a="n2hxp41",e="n2hxp40";export{a as mediaImage,e as mediaImageContainer};
